export default import.meta.ROLLUP_FILE_URL__GovWmjLkEHCNs6z6R2NYg